import { CancellationReasonChoice } from 'src/types';

export const CANCEL_SUBSCRIPTION_REASONS = [
  {
    value: CancellationReasonChoice.MISSING_FEATURES,
    label: 'Missing features',
  },
  {
    value: CancellationReasonChoice.PRODUCT_FEATURE_ISSUES,
    label: 'Product feature issues',
  },
  {
    value: CancellationReasonChoice.FOUND_BETTER_ALTERNATIVE,
    label: 'Found a better alternative',
  },
  {
    value: CancellationReasonChoice.TOO_EXPENSIVE,
    label: 'It’s too expensive',
  },
  {
    value: CancellationReasonChoice.DONT_KNOW_HOW_TO_USE,
    label: 'I don’t know how to use it',
  },
  {
    value: CancellationReasonChoice.NO_LONGER_NEED_PRODUCT,
    label: 'I no longer need it',
  },
  { value: CancellationReasonChoice.OTHER, label: 'Other' },
];

export const PLACEHOLDER_BY_REASON: Partial<
  Record<CancellationReasonChoice, string>
> = {
  [CancellationReasonChoice.MISSING_FEATURES]: 'Describe missing features',
  [CancellationReasonChoice.PRODUCT_FEATURE_ISSUES]:
    'Describe product feature issues',
};
